import { render } from "./BookList.vue?vue&type=template&id=23fe0821"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__